

















































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import PopoverResponsavel from '@/components/PopoverResponsavel.vue'
import {ListPanelUserSchema} from '@/schema/resource/PanelUser/ListPanelUserSchema'
import {PanelUserCollection} from '@/model/collection/PanelUserCollection'
import PopoverPanelUser from '@/components/PopoverPanelUser.vue'
import {ExportPanelUserSchema} from '@/schema/resource/PanelUser/ExportPanelUserSchema'

@Component({
  components: {PopoverPanelUser, PopoverResponsavel},
})
export default class ListPanelUserView extends Mixins(MixinQueryRouter) {
  schema = new ListPanelUserSchema()
  collection = new PanelUserCollection()

  async created() {
    this.collection.perPage = 20
    await this.query()
  }

  async showResponsavelPopover(resp: Responsavel, index: number) {
    await this.$nextTick()
    this.$tip.show(`panelUser${index}`, resp)
  }

  getInactiveClass(index: number) {
    return this.collection.get(index).active ? '' : 'inactive'
  }
  async downloadXlsx() {
    const {ascending, orderBy, page, limit, ...params} = this.collection.params

    const collection = new PanelUserCollection()
      .clearFilters()
      .addFilter(params)

    await collection.listCsvPanelUser()
    this.$xlsx.downloadFromSchema(
      collection.all(),
      new ExportPanelUserSchema(),
      $.t('schema.ExportPanelUser.title') as string
    )
  }
}
